export enum CellColor {
  Selected = 'Selected',
  Marked = 'Marked',
  LoadingAvailable = 'LoadingAvailable',
  Secondary = 'Secondary',
  Default = 'Default'
}
